import { useEffect } from "react";

// Lightweight per-page SEO: updates the document title, meta description,
// canonical URL and Open Graph / Twitter tags on route change. No dependency.
const SITE_URL = "https://telopeaparkschoolooshc.com";
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;

const upsertMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const Seo = ({ title, description, path = "/" }) => {
  useEffect(() => {
    const url = `${SITE_URL}${path}`;
    if (title) document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", DEFAULT_IMAGE);
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", DEFAULT_IMAGE);
    upsertCanonical(url);
  }, [title, description, path]);

  return null;
};

export default Seo;
